module.exports = __webpack_public_path__ + "34cfb2c202afbb6e8a687b3898d0f431.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/mx.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/mx.svg
// module chunks = 0